module.exports = __webpack_public_path__ + "static/media/ic_light_bolt.59eb049b.svg";